import vm from "../main";
import axios from "./PointrCloudAxios";

export default class PublishService {
  static async getSitePublishStatuses(clientInternalIdentifier) {
    let response;
    try {
      //TODO: Change this with correct endpoint
      response = await axios.get(`content/draft/clients/${clientInternalIdentifier}/sites/statuses`);
    } catch (error) {
      console.error(error);
      return error?.response?.data;
    }
    return response?.data;
  }

  static async getSingleSitePublishStatuses(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    try {
      response = await axios.get(
        `content/publisher/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/publish-contents-status`
      );
    } catch (error) {
      console.error(error);
      return error?.response?.data;
    }
    return response?.data;
  }

  static async publishSite(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(
        `content/publisher/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/publish-contents`
      );
    } catch (error) {
      console.error(error);

      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }

    return response.data;
  }

  static async getConfigurationClientPublishStatus(clientInternalIdentifier) {
    let response;
    try {
      response = await axios.get(`content/publisher/clients/${clientInternalIdentifier}/publish-configurations-status`);
    } catch (error) {
      console.error(error);
      return error?.response?.data;
    }
    return response?.data;
  }

  static async getSiteConfigurationPublishStatus(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    try {
      response = await axios.get(
        `content/publisher/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/publish-configurations-status`
      );
    } catch (error) {
      console.error(error);
      return error?.response?.data;
    }
    return response?.data;
  }

  static async getMetadataPublishStatus(clientInternalIdentifier) {
    let response;
    try {
      response = await axios.get(`content/publisher/clients/${clientInternalIdentifier}/publish-client-status`);
    } catch (error) {
      console.error(error);
      return error?.response?.data;
    }
    return response?.data;
  }

  static async getPersonasPublishStatus(clientInternalIdentifier) {
    let response;
    try {
      response = await axios.get(`content/publisher/clients/${clientInternalIdentifier}/publish-personas-status`);
    } catch (error) {
      console.error(error);
      return error?.response?.data;
    }
    return response?.data;
  }

  static async publishClientConfiguration(clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`content/publisher/clients/${clientInternalIdentifier}/publish-configurations`);
    } catch (error) {
      console.error(error);
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }

    return response.data;
  }

  static async publishSiteConfiguration(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(
        `content/publisher/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}/publish-configurations`
      );
    } catch (error) {
      console.error(error);
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async publishMetadata(clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`content/publisher/clients/${clientInternalIdentifier}/publish-client`);
    } catch (error) {
      console.error(error);
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }

    return response.data;
  }

  static async publishPersonas(clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`content/publisher/clients/${clientInternalIdentifier}/publish-personas`);
    } catch (error) {
      console.error(error);
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }

    return response.data;
  }
}
